import React from 'react';
import { useTranslation } from 'react-i18next';
import { VrrDropdown, VrrInput } from '../../../shared_components';
import SimpleDate from '../../../../components/Budget/Boost/BoostModal/simple_date';
import { TSummary } from '../types';
import './Summary.scss';

const Summary: React.FC<TSummary> = ({
  campaignTotal,
  videoTotal,
  kpiTotal
}) => {
  const { t } = useTranslation();

  const onChange = () => {};

  return (
    <div className="import-data-modal-summary-container">
      <div className="summary-totals">
        <div className="summary-total">
          <div className="summary-total-number">{campaignTotal}</div>
          <div className="summary-total-title">
            {t('import_data.import_data_modal.3.type.campaign')}
          </div>
        </div>
        <div className="summary-total">
          <div className="summary-total-number">{videoTotal}</div>
          <div className="summary-total-title">
            {t('import_data.import_data_modal.3.type.video')}
          </div>
        </div>
        <div className="summary-total">
          <div className="summary-total-number">{kpiTotal}</div>
          <div className="summary-total-title">
            {t('import_data.import_data_modal.3.type.kpi')}
          </div>
        </div>
      </div>
      <div className="summary-form">
        <span>{t('import_data.import_data_modal.3.form.name')}</span>
        <VrrInput
          className="import-name"
          value=""
          onChangeAction={onChange}
          type="text"
        />
        <div className="import-summary-date">
          <div>
            <span>{t('import_data.import_data_modal.3.form.startDate')}</span>
            <SimpleDate onDateChange={onChange} />
          </div>
          <div>
            <span>{t('import_data.import_data_modal.3.form.endDate')}</span>
            <SimpleDate onDateChange={onChange} />
          </div>
        </div>
        <span>{t('import_data.import_data_modal.3.form.platform')}</span>
        <VrrDropdown list={[]} handleChangeAction={onChange} />
      </div>
    </div>
  );
};

export default Summary;
